import { CustomerType } from "@raskrask-dk/raskrask-utils";
import {Action} from "../../../action/action";
import type {BasisTypeState} from "../basistypestate";

export const SET_CUSTOMER_TYPE = "SET_CUSTOMER_TYPE";
export class SetCustomerType extends Action<typeof SET_CUSTOMER_TYPE, CustomerType> {
  readonly type = SET_CUSTOMER_TYPE;

  constructor(state: BasisTypeState, data?: CustomerType) {
    super(state, data);
  }

  public isValid(): boolean {
    return this.isDoable();
  }

  public isDoable(): boolean {
    return true;
  }
}
